import { concat, of, Subject } from 'rxjs';
import { multicast, ignoreElements, delay } from 'rxjs/operators';
export var delayComplete = function (time, scheduler) {
    return multicast(new Subject(), function (s) { return concat(s, of(void 0).pipe(delay(time, scheduler), ignoreElements())); });
};
//# sourceMappingURL=delayComplete.js.map